import {twMerge} from 'tailwind-merge';

export type CountProps = {
  number: number;
  className?: string;
  showZero?: boolean;
};
function Count({number: count, className, showZero = false}: CountProps) {
  const shouldDisplay = count > 0 || (showZero && count === 0);
  return shouldDisplay ? (
    <div
      className={twMerge(
        'flex h-3.5 w-3.5 flex-col justify-center bg-red-bright items-center p-0.5 rounded-full text-[9px] font-bold leading-3 text-white',
        className,
      )}>
      {count}
    </div>
  ) : null;
}
export default Count;
